import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { CdnImg } from '@webplatform/cdn-image';
import { useBreakpoint, useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBanner',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const markersBoardImageStyles = computed(() => {
  const styles = props.data.markersBoard?.styles;
  return isDesktop.value ? styles?.desktop : styles?.mobile;
});

return { __sfc: true,props, getAssetUrl, isDesktop, markersBoardImageStyles, CdnImg, handleImageSrc, handleImageAlt }
}

})